import { verifyAccessToLocalStorage } from './utils';
import { getCookiePrivacyRequired, getHasAcceptedCookies, getCookieSettings } from '../../publicSession/selectors';
import localStorageWrapper from '../../utils/localStorageWrapper';
export function checkCompliantLocalStorageAccess(state, key) {
    return verifyAccessToLocalStorage(key, getCookiePrivacyRequired(state), getHasAcceptedCookies(state), getCookieSettings(state));
}
export function getCompliantLocalStorageItem(state, key) {
    if (typeof window === 'undefined') {
        return null;
    }
    return checkCompliantLocalStorageAccess(state, key) ? localStorageWrapper.getItem(key) : null;
}
